import React from "react";
import "../../App.css";
import { useContext } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";

import { useSearch } from "../../contexts/searchContext";

import { useHasActiveSubscription } from "../../hooks/useSubscriptionStatus";
import PersonCard from "./PersonCard";
import CapturedImageCard from "./CapturedImageCard";
import { CognitoUserContext } from "../../contexts/cognitoUserContext";

export default function SlugSearchResults() {
  const { filteredPeople, matchSource, matchAccuracy, capturedImageS3Key } = useSearch();

  const { cognitoUser } = useContext(CognitoUserContext);

  // uncomment this analysePerson ();

  try {
    // here we call something that gets the result from Rekognition
  } catch (error) {
  }

  const isCurrent = useHasActiveSubscription();
  const blur = isCurrent ? 0 : 8;
  const blurFilter = `blur(${blur}px)`;

  if (filteredPeople.length === 0) {
    return <div />;
  } else {
    return (
      <Box className="App">
        <Grid
          container
          spacing={1}
          sx={{ filter: blurFilter }}
          alignItems="center"
          justifyContent="center"
        >
          {/* Show captured image card first if this is a face match result */}
          {matchSource === 'face_match' && capturedImageS3Key && (
            <Grid key="captured-image" item xs="auto">
              <CapturedImageCard
                s3Key={capturedImageS3Key}
                matchAccuracy={matchAccuracy}
              />
            </Grid>
          )}

          {filteredPeople.map((person) => (
            <Grid key={person.person_id} item xs="auto">
              <PersonCard
                person={person}
                active={isCurrent}
                matchSource={matchSource}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }
}
